export default {
  pt: {
    'shipments.maquinarioSection.deleted': 'Máquina excluída.',
    'shipments.maquinarioSection.machine': 'Máquina',
    'shipments.maquinarioSection.searchMachine': 'Buscar máquina…',
    'shipments.maquinarioSection.semMaquinaComPrancha': 'Nenhuma máquina com viagem de prancha para este contrato. Lance a viagem no Transporte de Máquina com o Local Destino no pivô desta frente ou com o Contrato Destino dela.',
    'shipments.maquinarioSection.operator': 'Operador',
    'shipments.maquinarioSection.searchOperator': 'Buscar operador…',
    'shipments.maquinarioSection.start': 'Início',
    'shipments.maquinarioSection.end': 'Fim',
    'shipments.maquinarioSection.hectaresQty': 'Q. Hectares',
    'shipments.maquinarioSection.operatorCode': 'Código OP.',
    'shipments.maquinarioSection.hotelLink': 'Abrir o link do hotel',
    'shipments.maquinarioSection.lodgingDesde': 'desde {{data}}',
    'shipments.maquinarioSection.lodgingVazioDica': 'Sem hospedagem em aberto para este operador. A hospedagem é registrada no módulo de Hospedagem.',
    'shipments.maquinarioSection.medicao': 'Medição {{numero}}',
    'shipments.maquinarioSection.medicaoDica': 'Número da medição do Protheus, pela ocorrência de campo equiparada',
    'shipments.maquinarioSection.naoEquiparada': 'Sem equiparação',
    'shipments.maquinarioSection.equiparadaDica': 'Equiparada à ocorrência de campo {{item}} da frente {{frente}} no Protheus',
    'shipments.maquinarioSection.naoEquiparadaDica': 'Esta linha ainda não foi equiparada a uma ocorrência de campo do Protheus',
    'shipments.maquinarioSection.lodging': 'Hospedagem',
    'shipments.maquinarioSection.lightFleet': 'Frota Leve',
    'shipments.maquinarioSection.notes': 'Observações',
    'shipments.maquinarioSection.deleteMachine': 'Excluir máquina',
    'shipments.maquinarioSection.machines': 'Máquinas',
    'shipments.maquinarioSection.hectares': 'Hectares',
    'shipments.maquinarioSection.hectaresFaltam': 'Faltam {{n}}',
    'shipments.maquinarioSection.hectaresPassam': 'Passam {{n}}',
    'shipments.maquinarioSection.hectaresDica': 'Hectares lançados no Maquinário sobre os hectares da Frente',
    'shipments.maquinarioSection.withoutMachine': 'Sem máquina',
    'shipments.maquinarioSection.machinery': 'Maquinário',
    'shipments.maquinarioSection.addMachine': 'Adicionar máquina',
    'shipments.maquinarioSection.empty': 'Nenhuma máquina nesta frente.',
    'shipments.maquinarioSection.deleteTitle': 'Excluir máquina?',
    'shipments.maquinarioSection.deleteMessage': '{{name}} será excluído. Esta ação não pode ser desfeita.',
    'shipments.maquinarioSection.thisRecord': 'este registro',
    'shipments.maquinarioSection.programacao': 'Programação',
    'shipments.maquinarioSection.semProgramacaoDica': 'A máquina ainda não entrou em nenhuma programação da Colheita desta frente.',
    'shipments.transferirMaquina.acao': 'Transferir para outro contrato',
    'shipments.transferirMaquina.titulo': 'Transferir máquina',
    'shipments.transferirMaquina.destino': 'Contrato de destino',
    'shipments.transferirMaquina.buscarDestino': 'Buscar frente…',
    'shipments.transferirMaquina.data': 'Data em que foi rodando',
    'shipments.transferirMaquina.aviso': 'O Transporte de Máquina ganha a viagem em que a máquina foi rodando, sem prancha, e a máquina entra no destino com o mesmo operador. Esta linha continua aqui do jeito que está.',
    'shipments.transferirMaquina.confirmar': 'Transferir',
    'shipments.transferirMaquina.erroDestino': 'Escolha o contrato de destino.',
    'shipments.transferirMaquina.erroData': 'Informe a data em que a máquina foi rodando.',
    'shipments.transferirMaquina.feito': 'Máquina transferida para {{frente}}. Viagem {{registro}} no Transporte de Máquina.',
  },
  en: {
    'shipments.maquinarioSection.deleted': 'Machine deleted.',
    'shipments.maquinarioSection.machine': 'Machine',
    'shipments.maquinarioSection.searchMachine': 'Search machine…',
    'shipments.maquinarioSection.semMaquinaComPrancha': 'No machine with a lowboy trip to this contract. Record the trip in Machine Transport with this front pivot as the Destination Place, or this front as the Destination Contract.',
    'shipments.maquinarioSection.operator': 'Operator',
    'shipments.maquinarioSection.searchOperator': 'Search operator…',
    'shipments.maquinarioSection.start': 'Start',
    'shipments.maquinarioSection.end': 'End',
    'shipments.maquinarioSection.hectaresQty': 'Qty. hectares',
    'shipments.maquinarioSection.operatorCode': 'Op. code',
    'shipments.maquinarioSection.hotelLink': 'Open the hotel link',
    'shipments.maquinarioSection.lodgingDesde': 'since {{data}}',
    'shipments.maquinarioSection.lodgingVazioDica': 'No open lodging for this operator. Lodging is recorded in the Lodging module.',
    'shipments.maquinarioSection.medicao': 'Measurement {{numero}}',
    'shipments.maquinarioSection.medicaoDica': 'Protheus measurement number, from the matched field occurrence',
    'shipments.maquinarioSection.naoEquiparada': 'Not matched',
    'shipments.maquinarioSection.equiparadaDica': 'Matched to field occurrence {{item}} of front {{frente}} in Protheus',
    'shipments.maquinarioSection.naoEquiparadaDica': 'This row has not been matched to a Protheus field occurrence yet',
    'shipments.maquinarioSection.lodging': 'Lodging',
    'shipments.maquinarioSection.lightFleet': 'Light fleet',
    'shipments.maquinarioSection.notes': 'Notes',
    'shipments.maquinarioSection.deleteMachine': 'Delete machine',
    'shipments.maquinarioSection.machines': 'Machines',
    'shipments.maquinarioSection.hectares': 'Hectares',
    'shipments.maquinarioSection.hectaresFaltam': '{{n}} to go',
    'shipments.maquinarioSection.hectaresPassam': '{{n}} over',
    'shipments.maquinarioSection.hectaresDica': 'Hectares entered in Machinery over the work front hectares',
    'shipments.maquinarioSection.withoutMachine': 'Without machine',
    'shipments.maquinarioSection.machinery': 'Machinery',
    'shipments.maquinarioSection.addMachine': 'Add machine',
    'shipments.maquinarioSection.empty': 'No machines on this work front.',
    'shipments.maquinarioSection.deleteTitle': 'Delete machine?',
    'shipments.maquinarioSection.deleteMessage': '{{name}} will be deleted. This action cannot be undone.',
    'shipments.maquinarioSection.thisRecord': 'this record',
    'shipments.maquinarioSection.programacao': 'Schedule',
    'shipments.maquinarioSection.semProgramacaoDica': 'The machine has not been in any Harvest schedule of this front yet.',
    'shipments.transferirMaquina.acao': 'Transfer to another contract',
    'shipments.transferirMaquina.titulo': 'Transfer machine',
    'shipments.transferirMaquina.destino': 'Destination contract',
    'shipments.transferirMaquina.buscarDestino': 'Search front…',
    'shipments.transferirMaquina.data': 'Date it drove itself',
    'shipments.transferirMaquina.aviso': 'Machine Transport gets the trip in which the machine drove itself, without a lowboy, and the machine joins the destination with the same operator. This row stays here as it is.',
    'shipments.transferirMaquina.confirmar': 'Transfer',
    'shipments.transferirMaquina.erroDestino': 'Choose the destination contract.',
    'shipments.transferirMaquina.erroData': 'Enter the date the machine drove itself.',
    'shipments.transferirMaquina.feito': 'Machine transferred to {{frente}}. Trip {{registro}} in Machine Transport.',
  },
  es: {
    'shipments.maquinarioSection.deleted': 'Máquina eliminada.',
    'shipments.maquinarioSection.machine': 'Máquina',
    'shipments.maquinarioSection.searchMachine': 'Buscar máquina…',
    'shipments.maquinarioSection.semMaquinaComPrancha': 'Ninguna máquina con viaje de plataforma para este contrato. Registre el viaje en Transporte de Máquina con el Local Destino en el pivote de esta frente o con su Contrato Destino.',
    'shipments.maquinarioSection.operator': 'Operador',
    'shipments.maquinarioSection.searchOperator': 'Buscar operador…',
    'shipments.maquinarioSection.start': 'Inicio',
    'shipments.maquinarioSection.end': 'Fin',
    'shipments.maquinarioSection.hectaresQty': 'Cant. hectáreas',
    'shipments.maquinarioSection.operatorCode': 'Código OP.',
    'shipments.maquinarioSection.hotelLink': 'Abrir el link del hotel',
    'shipments.maquinarioSection.lodgingDesde': 'desde {{data}}',
    'shipments.maquinarioSection.lodgingVazioDica': 'Sin hospedaje abierto para este operador. El hospedaje se registra en el módulo de Hospedaje.',
    'shipments.maquinarioSection.medicao': 'Medición {{numero}}',
    'shipments.maquinarioSection.medicaoDica': 'Número de la medición de Protheus, por la ocurrencia de campo equiparada',
    'shipments.maquinarioSection.naoEquiparada': 'Sin equiparación',
    'shipments.maquinarioSection.equiparadaDica': 'Equiparada a la ocurrencia de campo {{item}} del frente {{frente}} en Protheus',
    'shipments.maquinarioSection.naoEquiparadaDica': 'Esta línea aún no fue equiparada a una ocurrencia de campo de Protheus',
    'shipments.maquinarioSection.lodging': 'Hospedaje',
    'shipments.maquinarioSection.lightFleet': 'Flota liviana',
    'shipments.maquinarioSection.notes': 'Observaciones',
    'shipments.maquinarioSection.deleteMachine': 'Eliminar máquina',
    'shipments.maquinarioSection.machines': 'Máquinas',
    'shipments.maquinarioSection.hectares': 'Hectáreas',
    'shipments.maquinarioSection.hectaresFaltam': 'Faltan {{n}}',
    'shipments.maquinarioSection.hectaresPassam': 'Sobran {{n}}',
    'shipments.maquinarioSection.hectaresDica': 'Hectáreas cargadas en Maquinaria sobre las hectáreas del frente',
    'shipments.maquinarioSection.withoutMachine': 'Sin máquina',
    'shipments.maquinarioSection.machinery': 'Maquinaria',
    'shipments.maquinarioSection.addMachine': 'Añadir máquina',
    'shipments.maquinarioSection.empty': 'No hay máquinas en este frente de trabajo.',
    'shipments.maquinarioSection.deleteTitle': '¿Eliminar máquina?',
    'shipments.maquinarioSection.deleteMessage': 'Se eliminará {{name}}. Esta acción no se puede deshacer.',
    'shipments.maquinarioSection.thisRecord': 'este registro',
    'shipments.maquinarioSection.programacao': 'Programación',
    'shipments.maquinarioSection.semProgramacaoDica': 'La máquina todavía no entró en ninguna programación de Cosecha de esta frente.',
    'shipments.transferirMaquina.acao': 'Transferir a otro contrato',
    'shipments.transferirMaquina.titulo': 'Transferir máquina',
    'shipments.transferirMaquina.destino': 'Contrato de destino',
    'shipments.transferirMaquina.buscarDestino': 'Buscar frente…',
    'shipments.transferirMaquina.data': 'Fecha en que fue rodando',
    'shipments.transferirMaquina.aviso': 'Transporte de Máquina recibe el viaje en que la máquina fue rodando, sin plataforma, y la máquina entra en el destino con el mismo operador. Esta fila sigue aquí como está.',
    'shipments.transferirMaquina.confirmar': 'Transferir',
    'shipments.transferirMaquina.erroDestino': 'Elija el contrato de destino.',
    'shipments.transferirMaquina.erroData': 'Informe la fecha en que la máquina fue rodando.',
    'shipments.transferirMaquina.feito': 'Máquina transferida a {{frente}}. Viaje {{registro}} en Transporte de Máquina.',
  },
}
